export function useCurrencyFormatter() {
  const formatPrice = (
    amount: number | string,
    currency: string = "CLP",
    minimumFractionDigits: number = 0,
    locale: string = "es-CL"
  ): string => {
    const numericAmount = Number(amount);

    if (isNaN(numericAmount)) {
      console.warn(`Valor no numérico recibido en formatPrice:`, amount);
      return `${currency} 0`;
    }

    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: currency.match(/USD|EUR/)
          ? 2
          : minimumFractionDigits,
        maximumFractionDigits: 2,
      }).format(numericAmount);
    } catch (error) {
      console.error("Error formateando moneda:", error);
      return `${currency} ${numericAmount}`;
    }
  };

  const formatPricePersonalData = (
    amount: number | string,
    currency: "CLP" | "USD" | "EUR" = "CLP",
    locale: string = "es-CL"
  ): string => {
    const numericAmount = Number(amount);

    if (Number.isNaN(numericAmount)) {
      console.warn(
        `Valor no numérico recibido en formatPricePersonalData:`,
        amount
      );
      return "$0";
    }

    const isNegative = numericAmount < 0;
    const absoluteAmount = Math.abs(numericAmount);

    const fractionDigits = currency === "USD" || currency === "EUR" ? 2 : 0;

    const formattedNumber = new Intl.NumberFormat(locale, {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(absoluteAmount);

    const prefixMap: Record<typeof currency, string> = {
      CLP: "$",
      USD: "USD ",
      EUR: "€",
    };

    const prefix = prefixMap[currency];

    return isNegative
      ? `-${prefix}${formattedNumber}`
      : `${prefix}${formattedNumber}`;
  };

  return { formatPrice, formatPricePersonalData };
}
